import * as React from "react";
import { CssVarsProvider } from "@mui/joy/styles";
import CssBaseline from "@mui/joy/CssBaseline";
import Box from "@mui/joy/Box";
import Breadcrumbs from "@mui/joy/Breadcrumbs";
import Link from "@mui/joy/Link";
import Typography from "@mui/joy/Typography";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import Sidebar from "../components/Sidebar";
import Header from "../components/Utils/Header";
import { Link as RouterLink } from "react-router-dom";
import { ReactNode } from "react";

interface Props {
  children?: ReactNode;
  title?: string;
  visible?: boolean;
  button?: ReactNode;
  navigator?: ReactNode;
  data?: ReactNode;
  colour?: any;
  cBox?: boolean;
}

const DashboardLayout = ({
  children,
  title,
  button,
  visible,
  navigator,
  colour,
  data,
  cBox = false,
  ...props
}: Props) => {
  return (
    <CssVarsProvider disableTransitionOnChange>
      <CssBaseline />
      <Box sx={{ display: "flex", minHeight: "100vh" }}>
        <Header />
        <Sidebar />
        <Box
          component="main"
          className="MainContent"
          sx={{
            px: { xs: 2, md: 6 },
            pt: {
              xs: "calc(12px + var(--Header-height))",
              sm: "calc(12px + var(--Header-height))",
              md: 3,
            },
            pb: { xs: 2, sm: 2, md: 3 },
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
            height: "100vh",
            gap: 1,
            overflow: "auto",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Breadcrumbs
              size="sm"
              aria-label="breadcrumbs"
              separator={<ChevronRightRoundedIcon fontSize="small" />}
              sx={{ pl: 0 }}
            >
              <Link
                underline="none"
                color="neutral"
                component={RouterLink}
                to="/dashboard"
                aria-label="Home"
              >
                <HomeRoundedIcon />
              </Link>
              {navigator}
              <Typography color="primary" fontWeight={500} fontSize={12}>
                {title}
              </Typography>
            </Breadcrumbs>
          </Box>
          <Box
            sx={{
              display: "flex",
              mb: 1,
              gap: 1,
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "start", sm: "center" },
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            <Typography level="h2" component="h1">
              {title}
            </Typography>
            {cBox && <>{data}</>}
            {visible ? button : <></>}
          </Box>
          {children}
        </Box>
      </Box>
    </CssVarsProvider>
  );
};

export default DashboardLayout;
